import { oBase, Ilk, oBool, oColor, oCsv, oDaton, oDatim, oDouble, oFloat, oHomin, oInt16, oInt32, oInt64, oMay, oMemo, oText, oWkd } from "../util/ovars";
import { DIALOG_AUX_FUNCTIONS } from "../util/classes";
import { Whisper } from "../util/classes";
import { UTL } from "../util/classes";
import { TRANS } from "../util/classes";
import { Catlist } from "../util/classes";

export class DIALOG3 {
    // --- משתני רכיבים (Static Members) ---
    public static overlay_element: HTMLDivElement = null; // must be public cause called from outside
    private static popup_element: HTMLDivElement = null;
    private static caption_element: HTMLDivElement = null;
    private static case_element: HTMLDivElement = null;
    private static d1_element: HTMLDivElement = null;
    private static d2_element: HTMLDivElement = null;
    private static d3_element: HTMLDivElement = null;
    private static d4_element: HTMLDivElement = null;
    private static d5_element: HTMLDivElement = null;
    private static d6_element: HTMLDivElement = null;
    private static d7_element: HTMLDivElement = null;
    private static d8_element: HTMLDivElement = null;
    private static slash1_element: HTMLDivElement = null;
    private static slash2_element: HTMLDivElement = null;
    private static close_button_element: HTMLSpanElement = null;
    private static defo_button_element: HTMLSpanElement = null; // defo = DEbug FOcu
    private static panel_element: HTMLDivElement = null;
    private static ok_button_element: HTMLButtonElement = null;
    private static cancel_button_element: HTMLButtonElement = null;
    private static erase_button_element: HTMLButtonElement = null;

    // --- משתני מצב ---
    private static MD_FLAG: boolean = false;
    private static defo_button_is_clicked: boolean = false;
    private static Vamod_MouseX: number = 0;
    private static Vamod_MouseY: number = 0;
    private static Vamod_ModalWindowLeftX: number = 0;
    private static Vamod_ModalWindowTopY: number = 0;
    private static par_callback_function: Function = null;
    private static par_input_OBJ: oDaton = null;
    private static var_CursorPosition: number = 1;
    private static par_wisper: Whisper = null;

    public static readonly BID = {
        UNDEFINED: 0,
        OK: 1,
        CANCEL: 2,
        ERASE: 3
    };

    private static var_current_pseudo_focused_btn: number = DIALOG3.BID.OK;

    // --- פונקציות המחלקה ---

    private static refresh_pseudo_focus_for_all_buttons(): void {
        DIALOG_AUX_FUNCTIONS.put_pseudo_focus_indcator(DIALOG3.ok_button_element, DIALOG3.var_current_pseudo_focused_btn == DIALOG3.BID.OK);
        DIALOG_AUX_FUNCTIONS.put_pseudo_focus_indcator(DIALOG3.cancel_button_element, DIALOG3.var_current_pseudo_focused_btn == DIALOG3.BID.CANCEL);
        DIALOG_AUX_FUNCTIONS.put_pseudo_focus_indcator(DIALOG3.erase_button_element, DIALOG3.var_current_pseudo_focused_btn == DIALOG3.BID.ERASE);
    }

    private static respond_tab(): void {
        DIALOG3.var_current_pseudo_focused_btn = UTL.GET_NEW_INDEX_Forward(DIALOG3.var_current_pseudo_focused_btn, DIALOG3.BID.OK, DIALOG3.BID.ERASE);
        DIALOG3.refresh_pseudo_focus_for_all_buttons();
    }

    private static respond_shift_tab(): void {
        DIALOG3.var_current_pseudo_focused_btn = UTL.GET_NEW_INDEX_Backward(DIALOG3.var_current_pseudo_focused_btn, DIALOG3.BID.OK, DIALOG3.BID.ERASE);
        DIALOG3.refresh_pseudo_focus_for_all_buttons();
    }

    private static create_overlay_element(): HTMLDivElement {
        const overlay_element = document.createElement("div");
        overlay_element.style.position = "fixed";
        overlay_element.style.top = "0";
        overlay_element.style.left = "0";
        overlay_element.style.width = "100%";
        overlay_element.style.height = "100%";
        overlay_element.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
        overlay_element.style.zIndex = "1000";
        return overlay_element;
    }

    private static create_popup_element(): HTMLDivElement {
        const popup_element = document.createElement("div");
        popup_element.id = "id-DIALOG3-popup";
        popup_element.style.position = "absolute";
        popup_element.style.backgroundColor = "#fff";
        popup_element.style.padding = "0px";
        popup_element.style.borderRadius = "8px";
        popup_element.style.width = "315px";
        popup_element.style.textAlign = "center";
        return popup_element;
    }

    private static create_caption_element(): HTMLDivElement {
        const caption = document.createElement("div");
        caption.textContent = "DIALOG3";
        caption.style.fontSize = "24px";
        caption.style.fontWeight = "bold";
        caption.style.margin = "0px";
        caption.style.padding = "0px";
        caption.style.backgroundColor = DIALOG_AUX_FUNCTIONS.get_caption_backgroundColor();
        caption.style.color = DIALOG_AUX_FUNCTIONS.get_caption_forgroundColor();
        caption.style.borderTopLeftRadius = "5px";
        caption.style.borderTopRightRadius = "5px";
        caption.style.userSelect = "none";
        return caption;
    }

    private static create_close_button(): HTMLSpanElement {
        return DIALOG_AUX_FUNCTIONS.create_close_button_element();
    }

    private static create_defo_button(): HTMLSpanElement {
        return DIALOG_AUX_FUNCTIONS.create_defo_button_element();
    }

    private static create_case_element(): HTMLDivElement {
        const element = document.createElement("div");
        element.id = "id-DIALOG3-case";
        element.style.backgroundColor = "yellow";
        element.style.display = "flex";
        element.style.width = "300px";
        element.style.padding = "2px";
        element.style.margin = "auto";
        return element;
    }

    private static create_new_stit_element(): HTMLDivElement {
        const element = document.createElement("div");
        element.style.backgroundColor = "white";
        element.style.width = "30px";
        element.style.fontSize = "26px";
        element.style.margin = "1px";
        element.textContent = "X";
        element.style.userSelect = "none";
        return element;
    }

    private static create_new_slash_element(): HTMLDivElement {
        const element = document.createElement("div");
        element.style.width = "35px";
        element.style.textAlign = "center";
        element.style.backgroundColor = "yellow";
        element.style.fontSize = "26px";
        element.style.margin = "1px";
        element.textContent = "/";
        element.style.userSelect = "none";
        return element;
    }

    private static create_panel_element(): HTMLDivElement {
        const buttonsContainer = document.createElement("div");
        buttonsContainer.style.marginTop = "15px";
        buttonsContainer.style.display = "flex";
        buttonsContainer.style.justifyContent = "space-around";
        buttonsContainer.style.backgroundColor = DIALOG_AUX_FUNCTIONS.get_panel_backgroundColor();
        buttonsContainer.style.marginBottom = "7px";
        return buttonsContainer;
    }

    private static create_ok_button_element(): HTMLButtonElement {
        const element = DIALOG_AUX_FUNCTIONS.create_ok_button_element();
        UTL.MakeElementUnFocusable(element);
        return element;
    }

    private static create_cancel_button_element(): HTMLButtonElement {
        const element = DIALOG_AUX_FUNCTIONS.create_cancel_button_element();
        UTL.MakeElementUnFocusable(element);
        return element;
    }

    private static create_erase_button_element(): HTMLButtonElement {
        const element = DIALOG_AUX_FUNCTIONS.create_erase_button_element();
        UTL.MakeElementUnFocusable(element);
        return element;
    }

    private static overlay_mousedown(event: MouseEvent): void {
        const target_element = event.target as HTMLElement;
        if (target_element == DIALOG3.caption_element) {
            const popup_element_bounding_rect = DIALOG3.popup_element.getBoundingClientRect();
            DIALOG3.MD_FLAG = true;
            DIALOG3.Vamod_MouseX = event.clientX;
            DIALOG3.Vamod_MouseY = event.clientY;
            DIALOG3.Vamod_ModalWindowLeftX = popup_element_bounding_rect.left; // parseFloat
            DIALOG3.Vamod_ModalWindowTopY = popup_element_bounding_rect.top; // parseFloat
        }
        if (target_element == DIALOG3.defo_button_element) {
            DIALOG3.defo_button_is_clicked = true;
        }
        if (target_element == DIALOG3.d1_element) { DIALOG3.var_CursorPosition = 1; DIALOG3.mark_current_digit(); }
        if (target_element == DIALOG3.d2_element) { DIALOG3.var_CursorPosition = 2; DIALOG3.mark_current_digit(); }
        if (target_element == DIALOG3.d3_element) { DIALOG3.var_CursorPosition = 3; DIALOG3.mark_current_digit(); }
        if (target_element == DIALOG3.d4_element) { DIALOG3.var_CursorPosition = 4; DIALOG3.mark_current_digit(); }
        if (target_element == DIALOG3.d5_element) { DIALOG3.var_CursorPosition = 5; DIALOG3.mark_current_digit(); }
        if (target_element == DIALOG3.d6_element) { DIALOG3.var_CursorPosition = 6; DIALOG3.mark_current_digit(); }
        if (target_element == DIALOG3.d7_element) { DIALOG3.var_CursorPosition = 7; DIALOG3.mark_current_digit(); }
        if (target_element == DIALOG3.d8_element) { DIALOG3.var_CursorPosition = 8; DIALOG3.mark_current_digit(); }
    }

    private static overlay_mousemove(event: MouseEvent): void {
        if (DIALOG3.MD_FLAG == true) {
            const delta_x = event.clientX - DIALOG3.Vamod_MouseX;
            const delta_y = event.clientY - DIALOG3.Vamod_MouseY;
            DIALOG3.popup_element.style.left = (DIALOG3.Vamod_ModalWindowLeftX + delta_x) + "px";
            DIALOG3.popup_element.style.top = (DIALOG3.Vamod_ModalWindowTopY + delta_y) + "px";
        }
    }

    private static overlay_mouseup(event: MouseEvent): void {
        const freezed_defo_button_is_clicked = DIALOG3.defo_button_is_clicked;
        DIALOG3.MD_FLAG = false;
        DIALOG3.defo_button_is_clicked = false;
        if (freezed_defo_button_is_clicked == false) {
            DIALOG3.case_element.focus();
        }
    }

    private static perform_pseudo_focused_button(): void {
        if (DIALOG3.var_current_pseudo_focused_btn == DIALOG3.BID.OK) DIALOG3.perform_ok();
        if (DIALOG3.var_current_pseudo_focused_btn == DIALOG3.BID.CANCEL) DIALOG3.perform_cancel();
        if (DIALOG3.var_current_pseudo_focused_btn == DIALOG3.BID.ERASE) DIALOG3.perform_erase();
    }

    private static overlay_keydown(event: KeyboardEvent): void {
        //alert("3.k1")
        debugger;
        if (event.key === 'Enter') {
            DIALOG3.perform_pseudo_focused_button();
        }
        if (event.key === 'Escape') {
            DIALOG3.perform_cancel();
        }
        if (event.key === 'ArrowLeft') {
            event.preventDefault();
            if (DIALOG3.var_CursorPosition > 1) {
                DIALOG3.var_CursorPosition--;
                DIALOG3.mark_current_digit();
            }
        }
        if (event.key === 'ArrowRight') {
            event.preventDefault();
            if (DIALOG3.var_CursorPosition < 8) {
                DIALOG3.var_CursorPosition++;
                DIALOG3.mark_current_digit();
            }
        }
        if (event.key === 'ArrowUp') event.preventDefault();
        if (event.key === 'ArrowDown') event.preventDefault();
        if (event.key === 'Delete') DIALOG3.VK_DELETE();
        if (event.key === 'Backspace') DIALOG3.VK_BACK();
        if (event.key === 'Tab') {
            event.preventDefault();
            if (event.shiftKey == false) DIALOG3.respond_tab();
            if (event.shiftKey == true) DIALOG3.respond_shift_tab();
        }
        if (event.key === ' ') {
            event.preventDefault();
            DIALOG3.put_char_in_digit_element_given_digit_number(DIALOG3.var_CursorPosition, " ");
            if (DIALOG3.var_CursorPosition < 8) {
                DIALOG3.var_CursorPosition++;
                DIALOG3.mark_current_digit();
            }
            DIALOG3.case_element.focus();
        }
        if (UTL.string_contains_digit(event.key) == true) {
            event.preventDefault();
            const digit_as_number = TRANS.trans_digit_string_to_digit_number(event.key);
            const digit_str = TRANS.trans_digit_number_to_string(digit_as_number);
            DIALOG3.put_char_in_digit_element_given_digit_number(DIALOG3.var_CursorPosition, digit_str);
            if (DIALOG3.var_CursorPosition < 8) {
                DIALOG3.var_CursorPosition++;
                DIALOG3.mark_current_digit();
            }
        }
    }

    private static create_new_br_element(): HTMLBRElement {
        return document.createElement('br');
    }

    private static paint_colors_in_select_elements(element: HTMLElement, bval: boolean): void {
        if (bval == false) {
            element.style.backgroundColor = "white";
            element.style.color = "black";
        }
        if (bval == true) {
            element.style.backgroundColor = "blue";
            element.style.color = "white";
        }
    }


    private static trans_digit_number_to_digit_elemenet(digit_number: number): HTMLElement {
        if (digit_number == 1) return DIALOG3.d1_element;
        if (digit_number == 2) return DIALOG3.d2_element;
        if (digit_number == 3) return DIALOG3.d3_element;
        if (digit_number == 4) return DIALOG3.d4_element;
        if (digit_number == 5) return DIALOG3.d5_element;
        if (digit_number == 6) return DIALOG3.d6_element;
        if (digit_number == 7) return DIALOG3.d7_element;
        if (digit_number == 8) return DIALOG3.d8_element;
        return null;
    }

    private static trans_digit_elemenet_to_digit_number(digit_element: HTMLElement): number {
        if (digit_element == DIALOG3.d1_element) return 1;
        if (digit_element == DIALOG3.d2_element) return 2;
        if (digit_element == DIALOG3.d3_element) return 3;
        if (digit_element == DIALOG3.d4_element) return 4;
        if (digit_element == DIALOG3.d5_element) return 5;
        if (digit_element == DIALOG3.d6_element) return 6;
        if (digit_element == DIALOG3.d7_element) return 7;
        if (digit_element == DIALOG3.d8_element) return 8;
        return (-1);
    }

    private static mark_current_digit(): void {
        for (let digit_number = 1; digit_number <= 8; digit_number++) {
            let digit_element = DIALOG3.trans_digit_number_to_digit_elemenet(digit_number);
            if (digit_element == null) {
                alert("DIALOG3.mark_current_digit().digit_element == null");
                return;
            }
            if (digit_number == DIALOG3.var_CursorPosition) {
                digit_element.style.color = "white";
                digit_element.style.backgroundColor = "blue";
            } else {
                digit_element.style.color = "black";
                digit_element.style.backgroundColor = "white";
            }
        }
    }


    private static put_char_in_digit_element_given_digit_number(p_digit_number: number, p_digit_as_str: string): void {
        let digit_element = DIALOG3.trans_digit_number_to_digit_elemenet(p_digit_number);
        if (digit_element == null) {
            alert("DIALOG3.put_char_in_digit_element_given_digit_number().digit_element == null");
            return;
        }
        digit_element.textContent = p_digit_as_str;
    }


    private static PutDigit(p_digit_number: number, p_digit_as_number: number): void {
        if (p_digit_as_number != (-1)) {
            DIALOG3.put_char_in_digit_element_given_digit_number(p_digit_number, p_digit_as_number.toString());
        } else {
            DIALOG3.put_char_in_digit_element_given_digit_number(p_digit_number, " ");
        }
    }

    private static erase_all_digits(): void {
        for (let digit_number = 1; digit_number <= 8; digit_number++) {
            DIALOG3.put_char_in_digit_element_given_digit_number(digit_number, ' ');
        }
    }

    private static SetDigitsBy_par_daton(): void {
        if (DIALOG3.par_input_OBJ.OBJ_EXIST == false) {
            DIALOG3.erase_all_digits();
        } else {
            const daton = DIALOG3.par_input_OBJ.NUMBER_CONTENT;
            const mday = UTL.GET_DATON_MDAY(daton);
            const month = UTL.GET_DATON_MONTH(daton);
            const year = UTL.GET_DATON_YEAR(daton);
            DIALOG3.PutDigit(1, TRANS.trans_number_and_position_to_digit_as_int(mday, 1));
            DIALOG3.PutDigit(2, TRANS.trans_number_and_position_to_digit_as_int(mday, 0));
            DIALOG3.PutDigit(3, TRANS.trans_number_and_position_to_digit_as_int(month, 1));
            DIALOG3.PutDigit(4, TRANS.trans_number_and_position_to_digit_as_int(month, 0));
            DIALOG3.PutDigit(5, TRANS.trans_number_and_position_to_digit_as_int(year, 3));
            DIALOG3.PutDigit(6, TRANS.trans_number_and_position_to_digit_as_int(year, 2));
            DIALOG3.PutDigit(7, TRANS.trans_number_and_position_to_digit_as_int(year, 1));
            DIALOG3.PutDigit(8, TRANS.trans_number_and_position_to_digit_as_int(year, 0));
        }
    }

    private static GetDigit(digit_number: number): number {
        const digit_element = DIALOG3.trans_digit_number_to_digit_elemenet(digit_number);
        const digit_str = digit_element.textContent;
        if (digit_str.length == 0 || digit_str == " ") return (-1);
        return TRANS.trans_digit_string_to_digit_number(digit_str);
    }

    private static decode_MDAY(): number {
        const d1 = DIALOG3.GetDigit(1);
        const d2 = DIALOG3.GetDigit(2);
        let sum = 0;
        if (d1 != (-1)) sum = sum * 10 + d1;
        if (d2 != (-1)) sum = sum * 10 + d2;
        return sum;
    }

    private static decode_MONTH(): number {
        const d3 = DIALOG3.GetDigit(3);
        const d4 = DIALOG3.GetDigit(4);
        let sum = 0;
        if (d3 != (-1)) sum = sum * 10 + d3;
        if (d4 != (-1)) sum = sum * 10 + d4;
        return sum;
    }

    private static decode_YEAR(): number {
        const d5 = DIALOG3.GetDigit(5);
        const d6 = DIALOG3.GetDigit(6);
        const d7 = DIALOG3.GetDigit(7);
        const d8 = DIALOG3.GetDigit(8);
        let sum = 0;
        if (d5 != (-1)) sum = sum * 10 + d5;
        if (d6 != (-1)) sum = sum * 10 + d6;
        if (d7 != (-1)) sum = sum * 10 + d7;
        if (d8 != (-1)) sum = sum * 10 + d8;
        return sum;
    }

    private static decode_daton(): number {
        const mday = DIALOG3.decode_MDAY();
        const month = DIALOG3.decode_MONTH();
        const year = DIALOG3.decode_YEAR();
        if (mday == 0 && month == 0 && year == 0) return -1;
        let year_txt = year;
        if (0 <= year && year <= 60) year_txt = 1900 + year;
        if (60 < year && year < 99) year_txt = 300 + year;
        return UTL.MAKE_DATON(mday, month, year_txt);
    }

    private static create_result_OBJ(p_value_exist: boolean, p_value_conent: number): oDaton {
        const CONSTRUCTIOR = Object.getPrototypeOf(DIALOG3.par_input_OBJ).constructor;
        if (CONSTRUCTIOR === oDaton) {
            return new oDaton(p_value_exist, p_value_conent);
        }
        alert("DIALOG3.error unknwon object");
    }

    private static call_callback(p_change_flag: boolean, p_value_exist: boolean, p_value_conent: number): void {
        debugger;
        if (DIALOG3.par_callback_function != null) {
            document.body.removeChild(DIALOG3.overlay_element);
            const delay_in_milliseconds = 0;
            let OBJ = DIALOG3.create_result_OBJ(p_value_exist, p_value_conent);
            if (true) {
                setTimeout(DIALOG3.par_callback_function, delay_in_milliseconds, p_change_flag, OBJ);
            }
        } else {
            alert("DIALOG3_callback_function != null");
        }
    }

    private static perform_ok(): void {
        DIALOG3.call_callback(true, true, DIALOG3.decode_daton());
    }

    private static perform_defo(): void {
        UTL.show_which_element_has_focus();
    }

    private static perform_cancel(): void {
        DIALOG3.call_callback(false, false, -1);
    }

    private static perform_erase(): void {
        UTL.show_which_element_has_focus();
        return;
        // DIALOG3.call_callback(true, false, -1); // קוד מוערה מהמקור
    }

    private static VK_DELETE(): void {
        const FreezedCursor = DIALOG3.var_CursorPosition;
        if (FreezedCursor === 1) { DIALOG3.PutDigit(1, DIALOG3.GetDigit(2)); DIALOG3.PutDigit(2, -1); }
        if (FreezedCursor === 2) { DIALOG3.PutDigit(2, -1); }
        if (FreezedCursor === 3) { DIALOG3.PutDigit(3, DIALOG3.GetDigit(4)); DIALOG3.PutDigit(4, -1); }
        if (FreezedCursor === 4) { DIALOG3.PutDigit(4, -1); }
        if (FreezedCursor === 5) {
            DIALOG3.PutDigit(5, DIALOG3.GetDigit(6)); DIALOG3.PutDigit(6, DIALOG3.GetDigit(7));
            DIALOG3.PutDigit(7, DIALOG3.GetDigit(8)); DIALOG3.PutDigit(8, -1);
        }
        if (FreezedCursor === 6) { DIALOG3.PutDigit(6, DIALOG3.GetDigit(7)); DIALOG3.PutDigit(7, DIALOG3.GetDigit(8)); DIALOG3.PutDigit(8, -1); }
        if (FreezedCursor === 7) { DIALOG3.PutDigit(7, DIALOG3.GetDigit(8)); DIALOG3.PutDigit(8, -1); }
        if (FreezedCursor === 8) { DIALOG3.PutDigit(8, -1); }
    }

    private static VK_BACK(): void {
        const FreezedCursor = DIALOG3.var_CursorPosition;
        if (FreezedCursor === 1) { DIALOG3.PutDigit(1, -1); DIALOG3.VK_DELETE(); DIALOG3.mark_current_digit(); }
        else if (FreezedCursor === 3 || FreezedCursor === 5) {
            DIALOG3.PutDigit(FreezedCursor, -1); DIALOG3.var_CursorPosition -= 1; DIALOG3.mark_current_digit();
        } else {
            DIALOG3.var_CursorPosition -= 1; DIALOG3.VK_DELETE(); DIALOG3.mark_current_digit();
        }
    }

    public static create_dialog(p_callback_function: Function, p_input_OBJ: oDaton, p_wisper: Whisper): void {
        DIALOG3.par_callback_function = p_callback_function;
        DIALOG3.par_input_OBJ = p_input_OBJ;
        DIALOG3.par_wisper = p_wisper;

        DIALOG3.overlay_element = DIALOG3.create_overlay_element();
        DIALOG3.popup_element = DIALOG3.create_popup_element();
        DIALOG3.caption_element = DIALOG3.create_caption_element();
        DIALOG3.close_button_element = DIALOG3.create_close_button();
        DIALOG3.defo_button_element = DIALOG3.create_defo_button();
        DIALOG3.case_element = DIALOG3.create_case_element();

        DIALOG3.d1_element = DIALOG3.create_new_stit_element();
        DIALOG3.d2_element = DIALOG3.create_new_stit_element();
        DIALOG3.d3_element = DIALOG3.create_new_stit_element();
        DIALOG3.d4_element = DIALOG3.create_new_stit_element();
        DIALOG3.d5_element = DIALOG3.create_new_stit_element();
        DIALOG3.d6_element = DIALOG3.create_new_stit_element();
        DIALOG3.d7_element = DIALOG3.create_new_stit_element();
        DIALOG3.d8_element = DIALOG3.create_new_stit_element();

        DIALOG3.slash1_element = DIALOG3.create_new_slash_element();
        DIALOG3.slash2_element = DIALOG3.create_new_slash_element();

        DIALOG3.panel_element = DIALOG3.create_panel_element();
        DIALOG3.ok_button_element = DIALOG3.create_ok_button_element();
        DIALOG3.cancel_button_element = DIALOG3.create_cancel_button_element();
        DIALOG3.erase_button_element = DIALOG3.create_erase_button_element();

        DIALOG3.overlay_element.appendChild(DIALOG3.popup_element);
        DIALOG3.caption_element.appendChild(DIALOG3.close_button_element);
        DIALOG3.caption_element.appendChild(DIALOG3.defo_button_element);
        DIALOG3.popup_element.appendChild(DIALOG3.caption_element);
        DIALOG3.popup_element.appendChild(DIALOG3.create_new_br_element());
        DIALOG3.popup_element.appendChild(DIALOG3.case_element);

        DIALOG3.case_element.appendChild(DIALOG3.d1_element);
        DIALOG3.case_element.appendChild(DIALOG3.d2_element);
        DIALOG3.case_element.appendChild(DIALOG3.slash1_element);
        DIALOG3.case_element.appendChild(DIALOG3.d3_element);
        DIALOG3.case_element.appendChild(DIALOG3.d4_element);
        DIALOG3.case_element.appendChild(DIALOG3.slash2_element);
        DIALOG3.case_element.appendChild(DIALOG3.d5_element);
        DIALOG3.case_element.appendChild(DIALOG3.d6_element);
        DIALOG3.case_element.appendChild(DIALOG3.d7_element);
        DIALOG3.case_element.appendChild(DIALOG3.d8_element);

        DIALOG3.popup_element.appendChild(DIALOG3.panel_element);
        DIALOG3.panel_element.appendChild(DIALOG3.ok_button_element);
        DIALOG3.panel_element.appendChild(DIALOG3.cancel_button_element);
        DIALOG3.panel_element.appendChild(DIALOG3.erase_button_element);

        DIALOG3.overlay_element.addEventListener("mousedown", DIALOG3.overlay_mousedown);
        DIALOG3.overlay_element.addEventListener("mousemove", DIALOG3.overlay_mousemove);
        DIALOG3.overlay_element.addEventListener("mouseup", DIALOG3.overlay_mouseup);
        DIALOG3.overlay_element.addEventListener("keydown", DIALOG3.overlay_keydown);
        DIALOG3.defo_button_element.addEventListener("click", DIALOG3.perform_defo);
        DIALOG3.ok_button_element.addEventListener("click", DIALOG3.perform_ok);
        DIALOG3.cancel_button_element.addEventListener("click", DIALOG3.perform_cancel);
        DIALOG3.erase_button_element.addEventListener("click", DIALOG3.perform_erase);
        DIALOG3.close_button_element.addEventListener("click", DIALOG3.perform_cancel);

        document.body.appendChild(DIALOG3.overlay_element);
        UTL.center_popup_element_inside_overlay_element(DIALOG3.popup_element, DIALOG3.overlay_element);

        DIALOG3.var_current_pseudo_focused_btn = DIALOG3.BID.OK;
        DIALOG3.refresh_pseudo_focus_for_all_buttons();
        DIALOG3.var_CursorPosition = 1;
        DIALOG3.mark_current_digit();
        UTL.MakeElementFocusable(DIALOG3.case_element);
        DIALOG3.SetDigitsBy_par_daton();
        DIALOG3.case_element.focus();
    }
}